import { CustomCellRendererProps } from 'ag-grid-react'

import { useTradersQuery } from '@/react-query/queries/static'

export interface TraderIdCellRendererProps extends CustomCellRendererProps<{
  trader_id: number | null
  client_id?: number | null
}> {}

export const TraderIdCellRenderer: React.FC<TraderIdCellRendererProps> = ({ value, node }) => {
  const client_id = node.data?.client_id

  const query = useTradersQuery({ org_id: client_id, is_internal: client_id ? false : true })

  const label = query.data?.find((t) => t.value === value)?.label ?? value

  return <>{label}</>
}
